import Image from "next/image";
import React, { useState } from "react";

const Preloader: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);


  if (loading) {
    return (
      <div 
        className={/*"position-fixed d-flex justify-content-center align-items-center start-0 end-0 top-0 bottom-0"*/""}
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div>
          <span className="loader" style={{ width: "40px", minHeight: '1px', display: 'inline-flex' }} />
        </div>
        <div>
          <h3>
            <Image
              src="/images/mas/logo.svg"
              alt="logo"
              width={200}
              height={200}
              priority
            />
          </h3>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default Preloader;
